var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedDownFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 29,
    viewBox: "0 0 84 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5V1L43 14L83.5 1V14.5L43 27.5L1 14.5Z",
    fill: "#C688EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 27.5L1 14.5V1L43 14M43 27.5L83.5 14.5V1L43 14M43 27.5V14",
    stroke: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDownFloor);
export default __webpack_public_path__ + "static/media/selected-down-floor.245435741e54f6ba12882d0231be72a8.svg";
export { ForwardRef as ReactComponent };